export interface Show {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  cover: string;
  coverWidth: number;
  coverHeight: number;
  description: string;
  host: string;
  episodes: number;
  updateDay: string;
  heat: number;
  rating: number;
  tags: string[];
  releaseDate: string;
}

export const shows: Show[] = [
  {
    id: 1,
    title: "中国好声音2026",
    category: "音乐综艺",
    categorySlug: "music",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20music%20singing%20competition%20stage%20with%20colorful%20lights%20and%20performers%2C%20cinematic%20poster%20style%2C%20dramatic%20lighting%2C%20warm%20red%20and%20gold%20tones%2C%20entertainment%20poster%20design%2C%20minimalist%20clean%20background&width=600&height=800&seq=show-cover-01&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "全国最具影响力的音乐选秀节目，四位导师盲选学员，打造华语乐坛新星。",
    host: "浙江卫视",
    episodes: 12,
    updateDay: "每周五",
    heat: 9850000,
    rating: 9.2,
    tags: ["音乐", "选秀", "竞技"],
    releaseDate: "2026-01-15",
  },
  {
    id: 2,
    title: "奔跑吧·黄河篇",
    category: "户外真人秀",
    categorySlug: "outdoor",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20outdoor%20reality%20show%20poster%20with%20celebrities%20running%20in%20scenic%20yellow%20river%20landscape%2C%20adventure%20theme%2C%20warm%20sunset%20lighting%2C%20cinematic%20style%2C%20clean%20composition%2C%20entertainment%20design&width=600&height=800&seq=show-cover-02&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "明星嘉宾沿黄河流域展开冒险之旅，体验各地风土人情与挑战任务。",
    host: "浙江卫视",
    episodes: 10,
    updateDay: "每周六",
    heat: 10200000,
    rating: 9.5,
    tags: ["户外", "冒险", "旅行"],
    releaseDate: "2026-03-20",
  },
  {
    id: 3,
    title: "吐槽大会第六季",
    category: "脱口秀",
    categorySlug: "talkshow",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20talk%20show%20poster%20with%20comedian%20on%20stage%20spotlight%2C%20humorous%20atmosphere%2C%20warm%20stage%20lighting%2C%20entertainment%20design%2C%20clean%20dark%20background%2C%20minimalist%20poster&width=600&height=800&seq=show-cover-03&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "明星互相吐槽的喜剧脱口秀，笑料不断，金句频出。",
    host: "腾讯视频",
    episodes: 10,
    updateDay: "每周日",
    heat: 8750000,
    rating: 9.0,
    tags: ["脱口秀", "喜剧", "明星"],
    releaseDate: "2026-02-10",
  },
  {
    id: 4,
    title: "极限挑战第十季",
    category: "竞技挑战",
    categorySlug: "competition",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20extreme%20challenge%20variety%20show%20poster%20with%20action%20scene%20and%20celebrities%20in%20urban%20setting%2C%20dramatic%20lighting%2C%20adventure%20theme%2C%20cinematic%20composition%2C%20clean%20background&width=600&height=800&seq=show-cover-04&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "极限男人帮再度集结，在城市中完成各种高难度挑战任务。",
    host: "东方卫视",
    episodes: 12,
    updateDay: "每周日",
    heat: 9560000,
    rating: 9.3,
    tags: ["挑战", "竞技", "搞笑"],
    releaseDate: "2026-04-05",
  },
  {
    id: 5,
    title: "向往的生活第八季",
    category: "生活观察",
    categorySlug: "lifestyle",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%20with%20rural%20countryside%20village%20house%20and%20warm%20sunlight%2C%20peaceful%20atmosphere%2C%20natural%20green%20scenery%2C%20cozy%20minimalist%20design%2C%20clean%20composition&width=600&height=800&seq=show-cover-05&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "明星嘉宾回归田园生活，自给自足，体验慢生活的美好。",
    host: "湖南卫视",
    episodes: 14,
    updateDay: "每周五",
    heat: 9120000,
    rating: 9.6,
    tags: ["慢综艺", "田园", "生活"],
    releaseDate: "2026-05-01",
  },
  {
    id: 6,
    title: "中餐厅第八季",
    category: "美食综艺",
    categorySlug: "food",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20food%20restaurant%20variety%20show%20poster%20with%20delicious%20dishes%20and%20warm%20kitchen%20atmosphere%2C%20culinary%20theme%2C%20golden%20lighting%2C%20gourmet%20design%2C%20clean%20minimalist%20background&width=600&height=800&seq=show-cover-06&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "明星在海外经营中餐厅，传播中华美食文化。",
    host: "湖南卫视",
    episodes: 12,
    updateDay: "每周五",
    heat: 8340000,
    rating: 9.1,
    tags: ["美食", "经营", "文化"],
    releaseDate: "2026-06-15",
  },
  {
    id: 7,
    title: "欢乐喜剧人第八季",
    category: "喜剧搞笑",
    categorySlug: "comedy",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20variety%20show%20poster%20with%20comedians%20performing%20on%20stage%2C%20bright%20colorful%20stage%20lights%2C%20joyful%20atmosphere%2C%20entertainment%20design%2C%20clean%20background%2C%20warm%20red%20tones&width=600&height=800&seq=show-cover-07&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "全国顶尖喜剧人同台竞技，带来最欢乐的喜剧盛宴。",
    host: "东方卫视",
    episodes: 12,
    updateDay: "每周日",
    heat: 7890000,
    rating: 8.9,
    tags: ["喜剧", "小品", "搞笑"],
    releaseDate: "2026-03-01",
  },
  {
    id: 8,
    title: "十三邀第九季",
    category: "访谈对话",
    categorySlug: "interview",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20interview%20talk%20show%20poster%20with%20two%20people%20having%20deep%20conversation%20in%20warm%20living%20room%20setting%2C%20intellectual%20atmosphere%2C%20soft%20natural%20lighting%2C%20minimalist%20design%2C%20clean%20background&width=600&height=800&seq=show-cover-08&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "许知远对话时代人物，探寻思想深处的精神世界。",
    host: "腾讯视频",
    episodes: 13,
    updateDay: "每周三",
    heat: 4560000,
    rating: 9.4,
    tags: ["访谈", "文化", "深度"],
    releaseDate: "2026-02-20",
  },
  {
    id: 9,
    title: "歌手·当打之年II",
    category: "音乐综艺",
    categorySlug: "music",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20singer%20competition%20variety%20show%20poster%20with%20solo%20performer%20on%20grand%20stage%2C%20dramatic%20spotlight%2C%20musical%20theme%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20design%2C%20clean%20dark%20background&width=600&height=800&seq=show-cover-09&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "顶级歌手同台竞演，用音乐诠释当打之年的力量。",
    host: "湖南卫视",
    episodes: 12,
    updateDay: "每周五",
    heat: 10250000,
    rating: 9.5,
    tags: ["音乐", "竞演", "歌手"],
    releaseDate: "2026-01-10",
  },
  {
    id: 10,
    title: "明星大侦探第十季",
    category: "竞技挑战",
    categorySlug: "competition",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20detective%20mystery%20variety%20show%20poster%20with%20dark%20room%20and%20mysterious%20atmosphere%2C%20crime%20scene%20investigation%20theme%2C%20dramatic%20shadow%20lighting%2C%20entertainment%20design%2C%20clean%20composition&width=600&height=800&seq=show-cover-10&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "明星化身侦探，在精心设计的案件场景中推理破案。",
    host: "芒果TV",
    episodes: 12,
    updateDay: "每周四",
    heat: 9450000,
    rating: 9.3,
    tags: ["推理", "悬疑", "明星"],
    releaseDate: "2026-04-10",
  },
  {
    id: 11,
    title: "非正式会谈第十季",
    category: "脱口秀",
    categorySlug: "talkshow",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20international%20cultural%20talk%20show%20poster%20with%20diverse%20young%20people%20sitting%20around%20table%2C%20friendly%20discussion%20atmosphere%2C%20warm%20studio%20lighting%2C%20multicultural%20theme%2C%20clean%20minimalist%20design&width=600&height=800&seq=show-cover-11&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "各国青年围绕热点话题展开讨论，展现多元文化视角。",
    host: "湖北卫视",
    episodes: 12,
    updateDay: "每周五",
    heat: 5670000,
    rating: 9.2,
    tags: ["辩论", "文化", "国际"],
    releaseDate: "2026-03-15",
  },
  {
    id: 12,
    title: "舌尖上的中国美食之旅",
    category: "美食综艺",
    categorySlug: "food",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20variety%20show%20poster%20with%20traditional%20Chinese%20cuisine%20closeup%2C%20steaming%20hot%20dishes%2C%20warm%20kitchen%20atmosphere%2C%20gourmet%20photography%2C%20clean%20dark%20background%2C%20rich%20colors&width=600&height=800&seq=show-cover-12&orientation=portrait",
    coverWidth: 600,
    coverHeight: 800,
    description: "走遍中国大地，探寻各地特色美食背后的文化与故事。",
    host: "央视",
    episodes: 8,
    updateDay: "每周六",
    heat: 7230000,
    rating: 9.7,
    tags: ["美食", "纪录片", "文化"],
    releaseDate: "2026-05-20",
  },
];